// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NextGenSwiper_TheComp__9LgJr"};